/**
 * @file index.js
 * @author Andres Solarte
 * @description Initialize IndiGlucoseMonitoringView View.
 */

// Commons
import {
  mapStateToProps,
  mapDispatchToProps
} from '@nephro/commons/mapReduxCRUD/index';

// Dependencies
import { connect } from 'react-redux';

// View
import View from './IndiGlucoseMonitoringView';

export const mapStateToPropsAmbulatoryMonitoring = mapStateToProps;
export const mapDispatchToPropsAmbulatoryMonitoring = mapDispatchToProps;

export default connect(
  mapStateToPropsAmbulatoryMonitoring,
  mapDispatchToPropsAmbulatoryMonitoring
)(View);
